import { Pdp } from '@ff-os/pdp-shared-registry/Pdp';
import { unwrap } from '@ff-os/shared-utils/unwrap';
import { selectAllVariants, selectPrintQuality } from '@ff-scene-plugins/photo-prints-redux/selectors/variantSelectors';
import { PhotoPrintsPdpState } from '@ff-scene-plugins/photo-prints-redux/store';
import { skuFor } from '@ff-scene-plugins/photo-prints-shared/variants';
import cuid from 'cuid';
import { sum, uniq } from 'lodash';

export const toOutputs = (state: PhotoPrintsPdpState): Pdp.Scene.Output[] => {

    const variants = selectAllVariants(state);
    const quality = selectPrintQuality(state);

    const groupOutputs = state.project.groups.ids
        .filter(id => quantityIn(state, id as string) > 0)
        .map(id => ({
            quantity: quantityIn(state, id as string),
            sku: skuFor(
                variants.find(v => state.project.groups.entities[id]!.variantId === v.id)!,
                quality)
        }));

    const skus = uniq(groupOutputs.map(go => go.sku));
    return skus.map(sku => ({
        sku: sku,
        cuid: cuid(),
        quantity: sum(groupOutputs.filter(go => go.sku === sku).map(go => go.quantity))
    }));
};

const quantityIn = (state: PhotoPrintsPdpState, groupId: string) => {

    const quantities = unwrap(state.project.photos)
        .filter(p => p.groupId === groupId)
        .map(p => p.quantity);

    return sum(quantities);
};